// extracted by mini-css-extract-plugin
export default {"scoreRow":"LDF9iwX7Z96u2wE72Xgy"};